var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('a',{attrs:{"href":"https://navigator.sk.ru/orn/1121707","target":"_blank","rel":"nofollow"}},[_c('span',{staticClass:"skolkovo-desktop"})])
}]

export { render, staticRenderFns }